import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BiDashboardComponent} from './bi-dashboard.component';
import {DxDashboardControlModule} from 'devexpress-dashboard-angular';
import {DevExtremeModule} from 'devextreme-angular';
import {InputPopupComponent} from '../dashboard/input-popup.component';

@NgModule({
	declarations: [
		BiDashboardComponent,
	],
	exports: [
		BiDashboardComponent,
	],
	imports: [
		CommonModule,
		DxDashboardControlModule,
		DevExtremeModule,
		InputPopupComponent,
	],
})
export class BiDashboardModule { }